
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import WhatsAppSelector from './WhatsAppSelector';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [whatsappOpen, setWhatsappOpen] = useState<boolean>(false);
  const location = useLocation();

  const navigation = [
    { name: 'Inicio', href: '/' },
    { name: 'Acerca de Nosotros', href: '/about' },
    { name: 'Productos y Servicios', href: '/products' },
    { name: 'Contacto', href: '/contact' },
  ];

  return (
    <header className="bg-black shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" onClick={() => window.scrollTo(0, 0)} className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/d6f2ccdac6f77d2976c5910b8b505f63.png" 
              alt="LION URBAN Logo" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => window.scrollTo(0, 0)}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === item.href
                    ? 'text-green-400 bg-green-900/30'
                    : 'text-white hover:text-green-400 hover:bg-green-900/20'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* WhatsApp Button */}
          <button
            onClick={() => setWhatsappOpen(true)}
            className="hidden md:flex items-center bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill mr-2"></i>
            WhatsApp
          </button>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-white hover:text-green-400 hover:bg-green-900/20 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-700">
            <div className="flex flex-col space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => {
                    setIsMenuOpen(false);
                    window.scrollTo(0, 0);
                  }}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer ${
                    location.pathname === item.href
                      ? 'text-green-400 bg-green-900/30'
                      : 'text-white hover:text-green-400 hover:bg-green-900/20'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <button
                onClick={() => {
                  setWhatsappOpen(true);
                  setIsMenuOpen(false);
                }}
                className="flex items-center bg-green-500 text-white px-3 py-2 rounded-lg hover:bg-green-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                WhatsApp
              </button>
            </div>
          </div>
        )}
      </div>

      <WhatsAppSelector
        isOpen={whatsappOpen}
        onClose={() => setWhatsappOpen(false)}
        productName="Consulta General"
      />
    </header>
  );
}